import React from "react";
import {Avatar, Popover} from "antd";
import {useAuth} from "../../authentication";
import {useHistory} from "react-router-dom";
import { useIntl } from "react-intl";

const UserProfile = () => {
  const {userSignOut,authUser} = useAuth();
  const history = useHistory();
  const intl = useIntl();

  const onLogoutClick = () => {
    userSignOut(() => {
      history.push('/');
    });
  }

  const userMenuOptions = (
    <ul className="gx-user-popover">
      {/* <li>My Account</li>
      <li>Connections</li> */}
      <li onClick={onLogoutClick}>{intl.formatMessage({id:"sidebar.user.profile.exit"})}
      </li>
    </ul>
  );

  return (
    <div className="gx-flex-row gx-align-items-center gx-mb-4 gx-avatar-row">
      <Popover placement="bottomRight" content={userMenuOptions} trigger="click">
        {/* <Avatar src={"https://w7.pngwing.com/pngs/340/946/png-transparent-avatar-user-computer-icons-software-developer-avatar-child-face-heroes.png"} className="gx-size-40 gx-pointer gx-mr-3" alt=""/> */}
        <span className="gx-avatar-name">{authUser?.displayName??authUser?.email}<i className="icon icon-chevron-down gx-fs-xxs gx-ml-2"/></span>
      </Popover>
    </div>
  )
};

export default UserProfile;
